import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr';
import { AdddecimalPipe } from '../adddecimal.pipe';
import { CompanyService } from '../service/company.service';
import { EnterpriseService } from '../service/enterprise.service';
import { ProjectService } from '../service/project.service';
import { AppraisalData } from './appraisalData';
import { Project } from '../models/project';

@Component({
  selector: 'app-enterpriseappraisal',
  templateUrl: './enterpriseappraisal.component.html',
  styleUrls: ['./enterpriseappraisal.component.css'],
})
export class EnterpriseappraisalComponent implements OnInit {
  constructor(
    private toastr: ToastsManager,
    vRef: ViewContainerRef,
    private enterpriseService: EnterpriseService,
    private companyService: CompanyService,
    private projectService: ProjectService
  ) {
    this.toastr.setRootViewContainerRef(vRef);

    this.data = new AppraisalData();
    this.project = new Project();
    this.companyId = localStorage.getItem('companyId');
    this.projectId = localStorage.getItem('projectId');
    this.print = false;
    this.showInstructions = false;
    this.loadData();
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() appraisalEmit: EventEmitter<any> = new EventEmitter();

  @Output() projectEmit: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId = '';

  companyId = '';

  companyLogoUrl = '';

  project: Project;

  data: AppraisalData;

  public barChartColors: any[] = [
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
    {
      backgroundColor: '#FFDFBA',
      borderColor: '#FFDFBA',
      pointBackgroundColor: '#FFDFBA',
      pointBorderColor: '#FFDFBA',
      pointHoverBackgroundColor: '#FFDFBA',
      pointHoverBorderColor: '#FFDFBA',
    },
    {
      backgroundColor: '#BAFFC9',
      borderColor: '#BAFFC9',
      pointBackgroundColor: '#BAFFC9',
      pointBorderColor: '#BAFFC9',
      pointHoverBackgroundColor: '#BAFFC9',
      pointHoverBorderColor: '#BAFFC9',
    },
  ];

  public barChartColors1: any[] = [
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
    {
      backgroundColor: '#BAFFC9',
      borderColor: '#BAFFC9',
      pointBackgroundColor: '#BAFFC9',
      pointBorderColor: '#BAFFC9',
      pointHoverBackgroundColor: '#BAFFC9',
      pointHoverBorderColor: '#BAFFC9',
    },
  ];

  public barChartColors2: any[] = [
    /* {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA'
    }, */
    {
      backgroundColor: '#FFDFBA',
      borderColor: '#FFDFBA',
      pointBackgroundColor: '#FFDFBA',
      pointBorderColor: '#FFDFBA',
      pointHoverBackgroundColor: '#FFDFBA',
      pointHoverBorderColor: '#FFDFBA',
    },
    {
      backgroundColor: '#BAFFC9',
      borderColor: '#BAFFC9',
      pointBackgroundColor: '#BAFFC9',
      pointBorderColor: '#BAFFC9',
      pointHoverBackgroundColor: '#BAFFC9',
      pointHoverBorderColor: '#BAFFC9',
    },
    {
      backgroundColor: '#7DA7D9',
      borderColor: '#7DA7D9',
      pointBackgroundColor: '#7DA7D9',
      pointBorderColor: '#7DA7D9',
      pointHoverBackgroundColor: '#7DA7D9',
      pointHoverBorderColor: '#7DA7D9',
    },
  ];

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: {
      fontFamily: 'Roboto',
      position: 'bottom',
      labels: {
        fontStyle: 'bold',
        boxWidth: 10,
        fontSize: 15,
        padding: 30,
        fontColor: 'black',
        margin: 50,
      },
    },
    tooltips: {
      callbacks: {
        label(tooltipItem) {
          return `$${tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          barPercentage: 0.5,
          ticks: {
            beginAtZero: true,
            stacked: true,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontColor: 'black',
            fontSize: 14,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: 'Roboto',
            fontSize: 14,
            fontColor: 'black',
            fontStyle: 'bold',
            callback(value) {
              // return value;
              const val = Math.round(value * 10) / 10;
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
      ],
    },
  };

  public barChartLabels: string[] = ['Initial', 'Stabilized', 'Future'];

  public barChartType = 'bar';

  public barChartLegend = true;

  isDataAvailable = 0;

  isDataAvailable1 = 0;

  isDataAvailable2 = 0;

  public barChartData: any[] = new Array();

  public barChartData1: any[] = new Array();

  public barChartData2: any[] = new Array();

  showInstructions: boolean;

  ngOnInit() {
    // To focus onto first input field when come to this page
    setTimeout(() => {
      document.getElementById('annualInflationRateFuture').focus();
    }, 1500);
  }

  // TO GET COMPANY LOGO DATA FROM DB THROUGH COMPANY SERVICE
  private processCompanyData(companyResponse) {
    this.companyLogoUrl = companyResponse.data[0].logoUrl;
  }

  // TO GET PROJECT NAME FROM PROJECT SERVICE FROM DB
  private processProjectData(projectObj) {
    // console.log(`Received object from API: ${JSON.stringify(projectObj, null, 2)}`);
    //
    // Clone the project object.
    //
    this.project = { ...projectObj };
    // console.log(`this.project = ${JSON.stringify(this.project, null, 2)}`);
  }

  private async processEnterpriseData(enterpriseData) {
    this.data.bedsCurrent = enterpriseData.data[0].beds_current;
    this.data.bedsCurrentInt = enterpriseData.data[0].beds_current;
    this.data.beds_potential = enterpriseData.data[0].beds_potential;
    this.data.beds_potential_int = enterpriseData.data[0].beds_potential;
    this.data.beds_future = enterpriseData.data[0].beds_future;
    this.data.beds_future_int = enterpriseData.data[0].beds_future;

    this.data.noiCurrent = Math.trunc(enterpriseData.data[0].noi_current);
    this.data.noiCurrentInt = enterpriseData.data[0].noi_current;
    this.data.noi_potential = enterpriseData.data[0].noi_potential;
    this.data.noi_potential_int = enterpriseData.data[0].noi_potential;
    this.data.noi_future = enterpriseData.data[0].noi_future;
    this.data.noi_future_int = enterpriseData.data[0].noi_future;

    this.data.noi_multiple_current = enterpriseData.data[0].noi_multiple_current;
    this.data.noi_multiple_current_int = enterpriseData.data[0].noi_multiple_current;
    this.data.noi_multiple_potential = enterpriseData.data[0].noi_multiple_potential;
    this.data.noi_multiple_potential_int = enterpriseData.data[0].noi_multiple_potential;
    this.data.noi_multiple_future = enterpriseData.data[0].noi_multiple_future;
    this.data.noi_multiple_future_int = enterpriseData.data[0].noi_multiple_future;

    this.data.square_foot_current = enterpriseData.data[0].square_foot_current;
    this.data.square_foot_current_int = enterpriseData.data[0].square_foot_current;
    this.data.square_foot_potential = enterpriseData.data[0].square_foot_potential;
    this.data.square_foot_potential_int = enterpriseData.data[0].square_foot_potential;
    this.data.square_foot_future = enterpriseData.data[0].square_foot_future;
    this.data.square_foot_future_int = enterpriseData.data[0].square_foot_future;

    this.data.price_square_foot_current = enterpriseData.data[0].price_square_foot_current;
    this.data.price_square_foot_current_int = enterpriseData.data[0].price_square_foot_current;
    this.data.price_square_foot_potential = enterpriseData.data[0].price_square_foot_potential;
    this.data.price_square_foot_potential_int = enterpriseData.data[0].price_square_foot_potential;
    this.data.price_square_foot_future = enterpriseData.data[0].price_square_foot_future;
    this.data.price_square_foot_future_int = enterpriseData.data[0].price_square_foot_future;
    this.data.monthly_rental_current = enterpriseData.data[0].monthly_rental_current;
    this.data.monthly_rental_current_int = enterpriseData.data[0].monthly_rental_current;
    this.data.monthly_rental_potential = enterpriseData.data[0].monthly_rental_potential;
    this.data.monthly_rental_potential_int = enterpriseData.data[0].monthly_rental_potential;
    this.data.monthly_rental_future = enterpriseData.data[0].monthly_rental_future;
    this.data.monthly_rental_future_int = enterpriseData.data[0].monthly_rental_future;

    this.data.capitalization_current = enterpriseData.data[0].capitalization_current;
    this.data.capitalization_current_int = enterpriseData.data[0].capitalization_current;
    this.data.capitalization_potential = enterpriseData.data[0].capitalization_potential;
    this.data.capitalization_potential_int = enterpriseData.data[0].capitalization_potential;
    this.data.capitalization_future = enterpriseData.data[0].capitalization_future;
    this.data.capitalization_future_int = enterpriseData.data[0].capitalization_future;

    this.data.currentValuationYear = enterpriseData.data[0].current_valuation_year;
    this.data.currentValuationYearInt = enterpriseData.data[0].current_valuation_year;
    this.data.potential_valuation_year = enterpriseData.data[0].potential_valuation_year;
    this.data.potential_valuation_year_int = enterpriseData.data[0].potential_valuation_year;
    this.data.future_valuation_year = enterpriseData.data[0].future_valuation_year;
    this.data.future_valuation_year_int = enterpriseData.data[0].future_valuation_year;
    this.data.annualInflationRateFuture = enterpriseData.data[0].annual_inflation_rate_future;
    this.data.annualInflationRateFutureInt = enterpriseData.data[0].annual_inflation_rate_future;

    this.data.resident_real_estate_value_current =
      enterpriseData.data[0].resident_real_estate_value_current;
    this.data.resident_real_estate_value_potential =
      enterpriseData.data[0].resident_real_estate_value_potential;
    this.data.resident_real_estate_value_future =
      enterpriseData.data[0].resident_real_estate_value_future;

    this.data.commercial_real_estate_value_current =
      enterpriseData.data[0].commercial_real_estate_value_current;
    this.data.commercial_real_estate_value_potential =
      enterpriseData.data[0].commercial_real_estate_value_potential;
    this.data.commercial_real_estate_value_future =
      enterpriseData.data[0].commercial_real_estate_value_future;

    this.data.ral_real_estate_value_current = enterpriseData.data[0].ral_real_estate_value_current;
    this.data.ral_real_estate_value_potential =
      enterpriseData.data[0].ral_real_estate_value_potential;
    this.data.ral_real_estate_value_future = enterpriseData.data[0].ral_real_estate_value_future;

    this.data.ral_business_value_current = enterpriseData.data[0].ral_business_value_current;
    this.data.ral_business_value_potential = enterpriseData.data[0].ral_business_value_potential;
    this.data.ral_business_value_future = enterpriseData.data[0].ral_business_value_future;

    this.data.ral_enterprise_appraisal_current =
      enterpriseData.data[0].ral_enterprise_appraisal_current;

    this.data.ral_enterprise_appraisal_potential =
      enterpriseData.data[0].ral_enterprise_appraisal_potential;

    this.data.ral_enterprise_appraisal_future =
      enterpriseData.data[0].ral_enterprise_appraisal_future;

    this.data.price_per_bed_business_real_estate_current =
      enterpriseData.data[0].price_per_bed_business_real_estate_current;

    this.data.price_per_bed_business_real_estate_potential =
      enterpriseData.data[0].price_per_bed_business_real_estate_potential;

    this.data.price_per_bed_business_real_estate_future =
      enterpriseData.data[0].price_per_bed_business_real_estate_future;

    this.data.price_per_bed_business_potential_current =
      enterpriseData.data[0].price_per_bed_business_potential_current;

    this.data.price_per_bed_business_potential_future =
      enterpriseData.data[0].price_per_bed_business_potential_future;

    this.data.ral_enterprise_apprisal_potential_current =
      enterpriseData.data[0].ral_enterprise_apprisal_potential_current;

    this.data.ral_enterprise_apprisal_potential_future =
      enterpriseData.data[0].ral_enterprise_apprisal_potential_future;

    this.data.ral_real_estate_value_potential_current =
      enterpriseData.data[0].ral_real_estate_value_potential_current;

    this.data.ral_real_estate_value_potential_future =
      enterpriseData.data[0].ral_real_estate_value_potential_future;

    this.data.ral_enterprise_business_value_potential_current =
      enterpriseData.data[0].ral_enterprise_business_value_potential_current;

    this.data.ral_enterprise_business_value_potential_future =
      enterpriseData.data[0].ral_enterprise_business_value_potential_future;

    this.data.price_per_bed_business_real_estate_future =
      enterpriseData.data[0].price_per_bed_business_real_estate_future;

    this.data.price_per_bed_business_real_estate_potential =
      enterpriseData.data[0].price_per_bed_business_real_estate_potential;

    this.data.price_per_bed_current = enterpriseData.data[0].price_per_bed_current;
    this.data.price_per_bed_potential = enterpriseData.data[0].price_per_bed_potential;
    this.data.price_per_bed_future = this.data.ral_business_value_future / this.data.beds_future;
    if (isNaN(this.data.price_per_bed_future)) {
      this.data.price_per_bed_future = 0;
    }

    this.data.capitalization_rate_current = enterpriseData.data[0].capitalization_rate_current;
    this.data.capitalization_rate_potential = enterpriseData.data[0].capitalization_rate_potential;
    this.data.capitalization_rate_future = enterpriseData.data[0].capitalization_rate_future;

    // CALL OTHER SET GRAPH FUNCTIONS THAT ARE USED IN ONINT()
    await this.graphFunction();
    await this.graphFunctionBusinessValue();
    await this.graphFunctionRALEntAppraisal();
    // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
    await this.appraisalEmit.emit({ appraisalEmit: true });
  }

  // TO SET GRAPH FOR REAL ESTATE VALUE
  graphFunction() {
    const barChartData = [];
    this.isDataAvailable = 1;
    barChartData.push({
      data: [
        this.data.resident_real_estate_value_current,
        this.data.resident_real_estate_value_potential,
        this.data.resident_real_estate_value_future,
      ],
      label: 'Residential Real Estate Value',
    });
    barChartData.push({
      data: [
        this.data.commercial_real_estate_value_current,
        this.data.commercial_real_estate_value_potential,
        this.data.commercial_real_estate_value_future,
      ],
      label: 'Commercial Real Estate Value',
    });
    barChartData.push({
      data: [
        this.data.ral_real_estate_value_current,
        this.data.ral_real_estate_value_potential,
        this.data.ral_real_estate_value_future,
      ],
      label: 'RAL Real Estate Value',
    });
    this.barChartData = barChartData;
  }

  // TO SET GRAPH FOR RAL BUSINESS VALUE
  graphFunctionBusinessValue() {
    // ral_business_value_future/beds_future
    const barChartData1 = [];
    this.isDataAvailable1 = 1;
    const futureBeds = Math.round(this.data.ral_business_value_future / this.data.beds_future);
    barChartData1.push({
      data: [
        this.data.price_per_bed_current,
        this.data.price_per_bed_potential,
        this.data.price_per_bed_future,
      ],
      label: 'Price Per Bed',
    });
    barChartData1.push({
      data: [
        this.data.ral_business_value_current,
        this.data.ral_business_value_potential,
        this.data.ral_business_value_future,
      ],
      label: 'RAL Business Value',
    });
    this.barChartData1 = barChartData1;
  }

  // TO SET GRAPH FOR RAL ENETRPRISE VALUE
  graphFunctionRALEntAppraisal() {
    const barChartData2 = [];
    this.isDataAvailable2 = 1;
    barChartData2.push({
      data: [
        this.data.ral_real_estate_value_current,
        this.data.ral_real_estate_value_potential,
        this.data.ral_real_estate_value_future,
      ],
      label: 'RAL Real Estate Value',
    });
    barChartData2.push({
      data: [
        this.data.ral_business_value_current,
        this.data.ral_business_value_potential,
        this.data.ral_business_value_future,
      ],
      label: 'RAL Business Value',
    });
    barChartData2.push({
      data: [
        this.data.ral_enterprise_appraisal_current,
        this.data.ral_enterprise_appraisal_potential,
        this.data.ral_enterprise_appraisal_future,
      ],
      label: 'RAL Enterprise Appraisal',
    });
    this.barChartData2 = barChartData2;
  }

  // COMBINE ALL GRAPGH FUNCTIONS
  graphFunctions() {
    this.graphFunction();
    this.graphFunctionBusinessValue();
    this.graphFunctionRALEntAppraisal();
  }

  // TO UPDATE REST OF SECTION'S FIELDS OF ENTERPRISE PAGE DATA ONCHANGE OF FIELD VALUE
  updateValue(event) {
    const fieldName = event.target.name;
    let value = this.replaceDollarsCommasPercentages(event.target.value);
    let calculatedValue: any = 0;
    const annual: any = this.data.annualInflationRateFuture;
    const futureValuation: any = this.data.future_valuation_year;
    calculatedValue = value * Math.pow(1 + annual / 100, futureValuation);

    // CONDITIONS TO CHECK WHETHER VALUE IS CHANGED OF NOT SO THAT SERVICE HIT WILL BE SAVED,
    // AS WE CAN'T USE CHANGE FUNCTION IN MASKING SO WE HAVE USE FOCUSOUT FUNCTION. FOR THAT THESE CHECKS ARE NECCESARY

    if (fieldName === 'annualInflationRateFuture') {
      // this.data.annualInflationRateFuture = value;
      if (value === this.data.annualInflationRateFutureInt) {
        return;
      }
      this.data.annualInflationRateFutureInt = value;
    } else if (fieldName === 'bedsCurrent') {
      // this.data.bedsCurrent = value;
      if (value === this.data.bedsCurrentInt) {
        return;
      }
      this.data.bedsCurrentInt = value;
    } else if (fieldName === 'beds_potential') {
      // this.data.beds_potential = value;
      if (value === this.data.beds_potential_int) {
        return;
      }
      this.data.beds_potential_int = value;
    } else if (fieldName === 'noiCurrent') {
      // this.data.noiCurrent = value;
      if (value === this.data.noiCurrentInt) {
        return;
      }
      this.data.noiCurrentInt = value;
    } else if (fieldName === 'noi_potential') {
      // this.data.noi_potential = value;
      if (value === this.data.noi_potential_int) {
        return;
      }
      this.data.noi_potential_int = value;
    } else if (fieldName === 'noi_multiple_current') {
      // this.data.noi_multiple_current = value;
      if (value === 0) {
        this.toastr.error('Must enter Cash Flow and Multiple to calculate RAL Business Value.');
      }
      if (value === this.data.noi_multiple_current_int) {
        return;
      }
      this.data.noi_multiple_current_int = value;
    } else if (fieldName === 'noi_multiple_potential') {
      // this.data.noi_multiple_potential = value;
      if (value === 0) {
        this.toastr.error('Must enter Cash Flow and Multiple to calculate RAL Business Value.');
      }
      if (value === this.data.noi_multiple_potential_int) {
        return;
      }
      this.data.noi_multiple_potential_int = value;
    } else if (fieldName === 'noi_multiple_future') {
      // this.data.noi_multiple_future = value;
      if (value === 0) {
        this.toastr.error('Must enter Cash Flow and Multiple to calculate RAL Business Value.');
      }
      if (value === this.data.noi_multiple_future_int) {
        return;
      }
      this.data.noi_multiple_future_int = value;
    } else if (fieldName === 'square_foot_current') {
      // this.data.square_foot_current = value;
      if (value === this.data.square_foot_current_int) {
        return;
      }
      this.data.square_foot_current_int = value;
    } else if (fieldName === 'square_foot_potential') {
      //  this.data.square_foot_potential = value;
      if (value === this.data.square_foot_potential_int) {
        return;
      }
      this.data.square_foot_potential_int = value;
    } else if (fieldName === 'price_square_foot_current') {
      // this.data.price_square_foot_current = value;
      if (value === this.data.price_square_foot_current_int) {
        return;
      }
      this.data.price_square_foot_current_int = value;
    } else if (fieldName === 'price_square_foot_potential') {
      // this.data.price_square_foot_potential = value;
      if (value === this.data.price_square_foot_potential_int) {
        return;
      }
      this.data.price_square_foot_potential_int = value;
    } else if (fieldName === 'monthly_rental_current') {
      // this.data.monthly_rental_current = value;
      if (value === this.data.monthly_rental_current_int) {
        return;
      }
      this.data.monthly_rental_current_int = value;
    } else if (fieldName === 'monthly_rental_potential') {
      // this.data.monthly_rental_potential = value;
      if (value === this.data.monthly_rental_potential_int) {
        return;
      }
      this.data.monthly_rental_potential_int = value;
    } else if (fieldName === 'capitalization_current') {
      // this.data.capitalization_current = value;
      if (value === 0) {
        this.toastr.error('Must enter Cap Rate to calculate RAL Business Value and Appraisals.');
      }
      if (value === this.data.capitalization_current_int) {
        return;
      }
      if (value >= 30) {
        value = 0;
        this.toastr.error('Maximum Cap Rate allowed is 29.');
        this.data.capitalization_current = 0;
        this.data.capitalization_current_int = 0;
      } else {
        this.data.capitalization_current_int = value;
      }
    } else if (fieldName === 'capitalization_potential') {
      // this.data.capitalization_potential = value;
      if (value === 0) {
        this.toastr.error('Must enter Cap Rate to calculate RAL Business Value and Appraisals.');
      }
      if (value === this.data.capitalization_potential_int) {
        return;
      }
      if (value >= 30) {
        value = 0;
        this.toastr.error('Maximum Cap Rate allowed is 29.');
        this.data.capitalization_potential = 0;
        this.data.capitalization_potential_int = 0;
      } else {
        this.data.capitalization_potential_int = value;
      }
    } else if (fieldName === 'capitalization_future') {
      // this.data.capitalization_future = value;
      if (value === 0) {
        this.toastr.error('Must enter Cap Rate to calculate RAL Business Value and Appraisals.');
      }
      if (value === this.data.capitalization_future_int) {
        return;
      }
      if (value >= 30) {
        value = 0;
        this.toastr.error('Maximum Cap Rate allowed is 29.');
        this.data.capitalization_future = 0;
        this.data.capitalization_future_int = 0;
      } else {
        this.data.capitalization_future_int = value;
      }
    } else if (fieldName === 'currentValuationYear') {
      // TODO: Whenever any of the valuation years are changed, read the new (annual) Net Cash Flow value from the Cash Flow table.
      // this.data.potential_valuation_year = value;
      if (value === this.data.currentValuationYearInt) {
        return;
      }
      this.data.currentValuationYearInt = value;
    } else if (fieldName === 'potential_valuation_year') {
      // this.data.potential_valuation_year = value;
      if (value === this.data.potential_valuation_year_int) {
        return;
      }
      this.data.potential_valuation_year_int = value;
    } else if (fieldName === 'future_valuation_year') {
      // this.data.future_valuation_year = value;
      if (value === this.data.future_valuation_year_int) {
        return;
      }
      this.data.future_valuation_year_int = value;
    }

    const data = {
      fieldName: event.target.name,
      value,
      projectId: this.projectId,
      calculatedValue,
      allVals: this.data,
    };

    this.enterpriseService.updateValue(data).subscribe((res) => {
      const keys = Object.keys(res.data);
      for (const key of keys) {
        this.data[key] = res.data[key];
      }
      // this.getEnterpriseData();
      this.graphFunctions();
    });
  }
  // UPDATE ENTERPRISE FIELDS END HERE

  // TO REMOVE DOLLER AND COMMAS FROM VALUES
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }

  checkNumber(ev) {
    let value = this.replaceDollarsCommasPercentages(ev.target.value);
    value = parseInt(value, 10);
    if (value > 10) {
      this.toastr.error('Maximum Multiple allowed is 10.');
      ev.target.value = 0;
    }
    ev.target.value = new AdddecimalPipe().transform(ev.target.value);
  }

  //
  // Load all of the data from various API calls.
  //
  private loadData() {
    this.enterpriseService.loadData(this.companyId, this.projectId).subscribe((combinedData) => {
      this.processEnterpriseData(combinedData[0]);
      this.processCompanyData(combinedData[1]);
      this.processProjectData(combinedData[2]);
      this.prepopulateValues();
    });
  }

  private setField(name, value) {
    this.updateValue({
      target: {
        name,
        value: value.toString(),
      },
    });
  }

  //
  // Fill in default values for the appraisal if they are unpopulated in the database.
  //
  private prepopulateValues() {
    // console.log(`Annual inflation rate: ${this.data.annualInflationRateFuture}`);
    if (this.data.annualInflationRateFuture === null && this.project.inflationRate !== null) {
      // console.log(`Setting future inflation rate to ${this.project.inflationRate}%`);
      this.data.annualInflationRateFuture = this.project.inflationRate;
      this.setField('annualInflationRateFuture', this.data.annualInflationRateFuture);
    }

    if (this.data.currentValuationYear === 0) {
      this.data.currentValuationYear = 1;
      this.setField('currentValuationYear', this.data.currentValuationYear);
    }

    if (this.data.potential_valuation_year === 0) {
      this.data.potential_valuation_year = 2;
      this.setField('potential_valuation_year', this.data.potential_valuation_year);
    }

    if (this.data.future_valuation_year === 0) {
      this.data.future_valuation_year = 5;
      this.setField('future_valuation_year', this.data.future_valuation_year);
    }

    //
    // The current number of occupied beds and the net cash flow are both based on the monthly records. If either
    // one needs to be set with a default value, read the data. Then update only the ones that need to be updated.
    //
    // console.log(`Number of beds: ${this.data.bedsCurrent}`);
    //
    if (
      this.data.bedsCurrent === 0 ||
      this.data.bedsCurrent === null ||
      this.data.noiCurrent === 0 ||
      this.data.noiCurrent === null
    ) {
      // console.log(`Reading yearly records for year ${this.data.currentValuationYear}`);

      //
      // We have to get the number of beds from the last month of the "currentValuationYear".
      //
      const data = {
        projectId: this.projectId,
        year: this.data.currentValuationYear,
      };
      this.projectService.getOccupiedBeds(data).subscribe((res) => {
        //
        // Access the last element in the data[] array because the array is sorted by month.
        //
        const monthObj = res.data[res.data.length - 1];

        if (this.data.bedsCurrent === 0 || this.data.bedsCurrent === null) {
          // console.log('Updating number of occupied beds');
          const occupiedBeds = monthObj.value;

          // console.log(`Found month ${monthObj.month} = ${occupiedBeds} beds`);
          this.data.bedsCurrent = occupiedBeds;
          this.setField('bedsCurrent', this.data.bedsCurrent);
        }

        if (this.data.noiCurrent === 0 || this.data.noiCurrent === null) {
          // console.log('Updating net cash flow');

          //
          // From the cash flow page, the net cash flow is calculated as the net operating expenses - debt service.
          // The net operating expenses is the GOI minus the "total_opex" property (whatever that is).
          //
          // TODO: Instead of calculating this, just pull it from the cash flow page "Projected Cash Flow Years 1-10",
          // line 14 (Net Cash Flow) for the year specified in the Initial "Valuation Year" on the EA page.
          //
          const netOpEx = monthObj.goi - monthObj.total_opex;
          const netCashFlow = netOpEx - monthObj.debt;
          // console.log(`Setting net cash flow to $${netCashFlow}`);
          this.data.noiCurrent = netCashFlow;
          this.setField('noiCurrent', this.data.noiCurrent);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/enterpriseappraisal/enterpriseappraisal.component.ts